import React from 'react';
import { Stack, Switch } from '@mui/material';
import { Typography } from '../../../../../components/typography/typography';

export interface IGoToRootEntityToggleProps {
    universe: string | undefined;
    checked?: boolean;
    onChange?: (checked: boolean) => void;
}

export function GoToRootEntityToggle(props: IGoToRootEntityToggleProps) {
    const { universe, checked, onChange } = props;

    function getRootEntityName() {
        switch (universe?.toLocaleLowerCase()) {
          case 'citizen':
            return 'Borger';
          case 'company':
            return 'Virksomhed';
        }
    }

    return (
        <Stack direction="row" spacing={1} alignItems="center">
            <Typography variant="caption">Gå til {getRootEntityName()}</Typography>
            <Switch
                color="secondary"
                size="small"
                checked={!!checked}
                onChange={(event: unknown, isChecked: boolean) => {
                    onChange && onChange(isChecked);
                }}
            />
        </Stack>
    );
}


